import React from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { DrawerFooter } from '../Navigation/navigationMenu';

import {
  FOOTER_LINKS,
  SITE_MAP,
  WIP_FOOTER_LINKS,
} from '../Navigation/RouteConstants';
import {
  PRIVACY_POLICY,
  TERMS_OF_USE,
  BROWSER_REQUIREMENTS,
  ACCESSIBILITY_COMPLIANCE,
  SITEMAP,
} from '../../Modules/ContentManagement/FooterLinks';
import { redirectURLLink } from '../CommonUtilities/commonUtilities';

function Footer({ print, main }) {
  const history1 = useHistory();
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();

  const handleLink = (linkName) => {
    if (linkName == PRIVACY_POLICY) {
      history1.push(FOOTER_LINKS, linkName);
    } else if (linkName === TERMS_OF_USE) {
      history1.push(FOOTER_LINKS, linkName);
    } else if (linkName === BROWSER_REQUIREMENTS) {
      history1.push(FOOTER_LINKS, linkName);
    } else if (linkName === ACCESSIBILITY_COMPLIANCE) {
      history1.push(FOOTER_LINKS, linkName);
    } else if (linkName === SITEMAP) {
      history1.push(SITE_MAP);
    } else {
      history1.push(WIP_FOOTER_LINKS);
    }
  };
  const handleRedirectURL = (URL, name) => {
    redirectURLLink(URL, name, history1, dispatch);
  };
  return (
    <>
      {!print ? (
        <div
          className="container-fluid"
          style={{ flex: '0 ' }}
          id="mainContentFooter"
        >
          <div className="main-footer row d-flex pt-3">
            <div className="col-lg-2">
              <DrawerFooter print />
            </div>
            <p className="footer-text col-lg-6">
              {/* ©2019 Conduent, Inc. All rights reserved. Conduent and Conduent
              Agile Star are trademarks of Conduent, Inc. and/or its
              subsidiaries in the United States and/or other countries */}
              {`@${currentYear} ${process.env.REACT_APP_COPYRIGHT_TEXT}`}
            </p>
            <div align="center" className="nav-menu footer-text col-lg-4">
              <span>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleLink(PRIVACY_POLICY);
                  }}
                  tile="Privacy Policy"
                >
                  Privacy Policy{' '}
                </a>
              </span>
              <span>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleRedirectURL(SITE_MAP, 'Site Map');
                  }}
                  title="Site Map"
                >
                  &nbsp;&nbsp;Site Map{' '}
                </a>
              </span>
              <span>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleLink(TERMS_OF_USE);
                  }}
                  title="Terms of Use"
                >
                  &nbsp;&nbsp;Terms of Use{' '}
                </a>
              </span>
              <span>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleLink(BROWSER_REQUIREMENTS);
                  }}
                  title="Browser Requirements"
                >
                  &nbsp;&nbsp; Browser Requirements{' '}
                </a>
              </span>
              <span>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleLink(ACCESSIBILITY_COMPLIANCE);
                  }}
                  title="Accessibility Compliance"
                >
                  &nbsp;&nbsp; Accessibility Compliance{' '}
                </a>
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="container-fluid pt-4 hide-on-screen"
          style={{ flex: '0 ' }}
        >
          <div className="row">
            <div style={{ width: '30%' }}>
              <DrawerFooter print />
            </div>
            <div style={{ width: '70%', padding: '0 1rem' }}>
              <div className="row">
                <p className="footer-text col-lg-12">
                  ©2019 Conduent, Inc. All rights reserved. Conduent and
                  Conduent Agile Star are trademarks of Conduent, Inc. and/or
                  its subsidiaries in the United States and/or other countries
                </p>
                <div className="nav-menu col-lg-12 d-flex justify-content-center">
                  <span
                    className={clsx(
                      'd-flex text-center mx-1',
                      print ? ' border-0' : ''
                    )}
                  >
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handleLink(PRIVACY_POLICY);
                      }}
                      title="Privacy Policy"
                    >
                      Privacy Policy
                    </a>
                  </span>
                  <span
                    className={clsx(
                      'd-flex text-center mx-1',
                      print ? ' border-0' : ''
                    )}
                  >
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handleLink(SITEMAP);
                      }}
                      title="Site Map"
                    >
                      Site Map{' '}
                    </a>
                  </span>
                  <span
                    className={clsx(
                      'd-flex text-center mx-1',
                      print ? ' border-0' : ''
                    )}
                  >
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handleLink(TERMS_OF_USE);
                      }}
                      title="Terms of Use"
                    >
                      Terms of Use{' '}
                    </a>
                  </span>
                  <span
                    className={clsx(
                      'd-flex text-center mx-1',
                      print ? ' border-0' : ''
                    )}
                  >
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handleLink(BROWSER_REQUIREMENTS);
                      }}
                      title="Browser Requirements"
                    >
                      {' '}
                      Browser Requirements{' '}
                    </a>
                  </span>
                  <span
                    className={clsx(
                      'd-flex text-center mx-1',
                      print ? ' border-0' : ''
                    )}
                  >
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handleLink(ACCESSIBILITY_COMPLIANCE);
                      }}
                      title="Accessibility Compliance"
                    >
                      {' '}
                      Accessibility Compliance
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;
